import logo_img from "@/assets/images/logo_greenpeace.png";

export default {
  payment: {
    showSinglePaymentCms: true,
  },

  intro: {
    visible: true,
    header: "Zrób prezent wilkom i sobie",
    isSubheaderVisible: false,
    img: logo_img,
  },

  pending_page: {
    intro: " Płatność jest w trakcie realizacji",
    error_0: "Niestety Twoja płatność nie powiodła się.",
    error_1: " Prosimy o ponowienie transakcji",
  },
  thankyou_single: {
    intro: "Dziękujemy!",
    content:
      'Bardzo dziękujemy za wsparcie naszych działań na rzecz ochrony dzikiej przyrody w Polsce. Twoja pomoc pozwala nam skutecznie działać na rzecz wilków i innych dzikich mieszkańców Polski!<div class="thanks__share py-4"> Zaproś znajomych do stworzenia wilczej walentynki:</div><div class="d-flex justify-content-center"></div>',
  },
  thankyou_single_plus: {
    intro: "Dziękujemy!",
    content:
      'Bardzo dziękujemy za wsparcie naszych działań na rzecz ochrony dzikiej przyrody w Polsce. Twoja pomoc pozwala nam skutecznie działać na rzecz wilków i innych dzikich mieszkańców Polski!<div class="thanks__share py-4"> Zaproś znajomych do stworzenia wilczej walentynki:</div><div class="d-flex justify-content-center"></div>',
  },
  thankyou_regular: {
    intro: "Dziękujemy!",
    content:
      'Bardzo dziękujemy za wsparcie naszych działań na rzecz ochrony dzikiej przyrody w Polsce. Twoja pomoc pozwala nam skutecznie działać na rzecz wilków i innych dzikich mieszkańców Polski!<div class="thanks__share py-4"> Zaproś znajomych do stworzenia wilczej walentynki:</div><div class="d-flex justify-content-center"></div>',
  },
  form_invitation: {
    header_1: "<div> Wesprzyj ochronę wilków</div>",
    introPayment:
      "Przed nami dużo pracy na rzecz zapewnienia wilkom bezpieczeństwa. Jeżeli możesz sobie na to pozwolić, wesprzyj nasze działania i pomóż nam robić to skutecznie.",
    chose_type: "Wybierz sposób wsparcia:",
    chose_type_when_only_subscription: "Sposób wsparcia",
    btn_cta: "POMAGAM!",
  },
  form: {
    btn_single: "jednorazowo",
    btn_subscription: "co miesiąc",
    subscription_modal_title: "Wspaniale, że chcesz pomagać wilkom",
    subscription_modal_subtitle:
      "Dzięki Twojemu wsparciu możemy skuteczniej chronić przyrodę!",
    subscription_modal_intro: "Lorem sub 2",
    single_modal_title: "Wspaniale, że chcesz pomóc wilkom",
    single_modal_subtitle: "Lorem",
    single_modal_intro: "Lorem lorem",
    btn_cta_modal: "POMAGAM",
    card_info: "Wpisz dane <b>karty MasterCard lub Visa</b>",
    agreement_1:
      "Wyrażam zgodę na przetwarzanie przez Greenpeace Polska moich danych",
    agreement_2:
      "Jeśli podajesz nam swój telefon, pamiętaj o zgodzie na kontakt telefoniczny :)",
    agreement_3: "mailowo",
    agreement_4: "telefonicznie (to są miłe telefony ;))",
    agreement_5:
      "Wyrażam zgodę na kontakt ze strony Greenpeace Polska w sprawie moich płatności i kampanii:",
    agreement_6:
      'Zgadzam się na zapisanie danych transakcji do kolejnych darowizn na rzecz akcji Greenpeace "Walentynka dla Wilka" oraz akceptuję <a target="_blak" href="https://poland.payu.com/wp-content/uploads/sites/14/2022/01/Regulamin-pojedynczej-transakcji-platniczej-PayU_2021_04-.pdf">regulamin PayU</a>.',
    agreement_7: "Ta zgoda jest niezbędna do wysłania Walentynki",
    agreement_8: "Wybierz metodę płatności:",
    legalNotice_1:
      "Pamiętaj, że w dowolnym momencie możesz przerwać lub zawiesić adopcję regularną. Jeśli masz pytanie odnośnie transakcji, napisz do nas na adres",
    legalNotice_2: "lub zadzwoń na numer",
    legalNotice_3: "od wtorku do piątku w godz.10-15.",
    legalNotice_4: "22 65 84 99",
    legalNotice_5: "spl@greenpeace.org",
    legalNotice_6:
      'Administratorem Twoich danych jest Fundacja Greenpeace Polska. Prosimy o zapoznanie się z <a href="https://www.greenpeace.org/poland/przetwarzanie-danych-osobowych-darczyncow/" target="_blank"><b>pełną klauzulą informacyjną </b></a>wyjaśniającą, jak przetwarzamy Twoje dane osobowe.',
    additional_field_1:
      "Klikając przycisk <i>Gotowe</i>, wyrażasz zgodę na przechowywanie i przetwarzanie danych osobowych przez Greenpeace Polska",
    additional_field_2: "zapasowe pole formularz 2",
    additional_field_3: "zapasowe pole formularz 3",
    errors: {
      min_regular: "Ups, minimalna liczba pszczół w adopcji regularnej: 10",
      max_regular:
        "Ups, maksymalna liczba pszczół w adopcji: 5 000 - chcesz zaadoptować więcej pszczół? Napisz do nas na spl@greenpeace.org",
      min_single: "Ups, minimalna liczba pszczół w adopcji jednorazowej: 1",
    },
  },

  footer: {
    address_1: "Fundacja Greenpeace Polska",
    address_2: "Altowa 4<br/> 02-386 Warszawa",
    mail: "info.poland@greenpeace.org",
    phone: "+48 22 659 84 99",
    partner_visible: false,
    partner_title: "PARTNER AKCJI",
    partner_img: logo_img,
    partner_link: "",
  },
  rules: {
    header: " regulamin",
    content: "Fundacja Greenpeace Polska",
  },
  privacy: {
    header: "Prywatność",
    content: "Fundacja Greenpeace Polska",
  },
  additional_fileds: {
    additional_field_1: "zapasowe pole 1",
    additional_field_2: "zapasowe pole 2",
    additional_field_3: "zapasowe pole 3",
  },
};
